import React, {ElementRef, MouseEvent, useState} from 'react'
import {useController} from 'react-hook-form'
import InputCheckBox from 'Src/components/InputCheckBox'
import {INPUT_NAMES, usePageContext} from 'Src/components/pages/SoftPull/PageContext'
import RegistrationTermsOfUse from 'Src/components/Registration/RegistrationTermsOfUse'
import {useFrameContext} from 'Src/contexts/FrameContext'
import {trans} from 'Src/utilities/Helpers'

const LegalCheckbox = () => {
  const {
    creditAppConfig: {privacy_policy_url: privacyPolicyUrl},
    dealership: {
      attributes: {name: dealershipName},
    },
  } = useFrameContext()
  const {control} = usePageContext()
  const {
    field,
    fieldState: {error},
  } = useController({
    control,
    name: INPUT_NAMES.LEGAL_CHECKBOX,
  })
  const [showTermsOfUse, setShowTermsOfUse] = useState(false)

  const handleTermsOfUseButtonClick = (event: MouseEvent<ElementRef<'button'>>) => {
    event.preventDefault()
    setShowTermsOfUse(true)
  }

  return (
    <>
      <div className="tw-mb-12">
        <label className="tw-flex tw-cursor-pointer tw-select-none tw-gap-4">
          <InputCheckBox className="tw-mt-0.5" checked={field.value} {...field} />
          {/* @TODO AZ-33737 Move this into en.json file */}
          <div className="tw-flex-1 tw-text-xs tw-text-brand-body_text--muted">
            I agree to have my credit file accessed for purposes of pre-qualifying for a vehicle
            loan. This is a soft inquiry and will not impact my credit score. I understand that I
            might not pre-qualify depending on the pre-qualification criteria. By submitting this
            form, I understand that I may be contacted by {dealershipName} and I agree to the{' '}
            <button className="link" onClick={handleTermsOfUseButtonClick}>
              {trans('terms_of_use')}
            </button>{' '}
            and{' '}
            <a href={privacyPolicyUrl} className="link" target="_blank" rel="noreferrer">
              {trans('privacy_policy')}
            </a>
            .{error?.message ? <div className="error tw-mt-2">{error.message}</div> : null}
          </div>
        </label>
      </div>
      <RegistrationTermsOfUse open={showTermsOfUse} onClose={() => setShowTermsOfUse(false)} />
    </>
  )
}

export default LegalCheckbox
